'use strict';

function _MortgageRedirectionController() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;

  this._redirectionSent = false;

  this._url = {
    MortgagePhoneVerification: '/member/dashboard/mortgage/phone-verification',
    MortgageDashboard: '/member/dashboard/mortgage',
    MortgageAppOptions: '/member/dashboard/mortgage/new/options',
    MortgageAppSigner: '/member/dashboard/mortgage/new/backup',
    MortgageAppEmployment: '/member/dashboard/mortgage/new/employment-info',
    MortgageAppLiability: '/member/dashboard/mortgage/new/liability',
    MortgageAppDetails: '/member/dashboard/mortgage/new/details',
    MortgageAppConsent: '/member/dashboard/mortgage/new/consent'
  };

  /*
      validateMortgagePageRequest
       Generic coverage function for all mortgage page requests
  */
  this.validateMortgagePageRequest = function () {
    if (this._redirectionSent) return false;

    for (var p in this._initFlags) {
      if (!this._initFlags[p]) return false;
    }

    // Check for mortgage functionality availability
    if (!this.presenter.hasAction('account.index_mortgage_applications')) {
      return false;
    }

    return true;
  };

  /*
      checkMortgageApplicationEligibility
       Coverage for loan flow application pages
  */
  this.checkMortgageApplicationEligibility = function () {
    return this._checkMortgageApplicationSection();
  };

  this._checkMortgageApplicationSection = function () {
    if (!this.presenter.getModelProperty('account.phone_number')) {
      // Phone Verification
      this._history.goToUrl(this._url.MortgagePhoneVerification);
      return false;
    }
    if (this.presenter.hasAction('account.create_mortgage_application') && !this.presenter.getModelProperty('mortgage.status')) {
      // Mortgage Options
      if (this._getCurrentUrl() != this._url.MortgageAppOptions) {
        this._history.goToUrl(this._url.MortgageAppOptions);
        return false;
      }
    } else if (this.presenter.hasAction('mortgage.update_mortgage_application')) {
      var redirectUrl = null;
      var allowedUrlsArr = [];
      if (!this._isMortgageOptionsComplete()) {
        if (redirectUrl == null) redirectUrl = this._url.MortgageAppOptions;
      } else {
        allowedUrlsArr.push(this._url.MortgageAppOptions);

        if (!this._isBackupSoloComplete()) {
          if (redirectUrl == null) redirectUrl = this._url.MortgageAppSigner;
        } else {
          allowedUrlsArr.push(this._url.MortgageAppSigner);

          if (!this._isEmploymentInfoComplete()) {
            if (redirectUrl == null) redirectUrl = this._url.MortgageAppEmployment;
          } else {
            allowedUrlsArr.push(this._url.MortgageAppEmployment);

            if (!this._isLiabilityDetailsComplete()) {
              if (redirectUrl == null) redirectUrl = this._url.MortgageAppLiability;
            } else {
              allowedUrlsArr.push(this._url.MortgageAppLiability);

              if (!this._isMortgageDetailsComplete()) {
                if (redirectUrl == null) redirectUrl = this._url.MortgageAppDetails;
              } else {
                allowedUrlsArr.push(this._url.MortgageAppDetails);

                if (!this._isConsentCheckComplete()) {
                  if (redirectUrl == null) redirectUrl = this._url.MortgageAppConsent;
                } else {
                  allowedUrlsArr.push(this._url.MortgageAppConsent);
                }
              }
            }
          }
        }
      }

      if (redirectUrl != null) {
        if (this._redirectPage(redirectUrl, allowedUrlsArr)) return false;
      }
    } else {
      // go to the dashboard as not allowed to update mortgage anymore
      window.location.replace(this._url.MortgageDashboard);
      return false;
    }
    return true;
  };

  /*
      Redirects the page to the redirectionUrl, unless the current URL is in the allowed list
  */
  this._redirectPage = function (redirectionUrl, allowedUrls) {
    if (this._getCurrentUrl() != redirectionUrl) {
      if (allowedUrls != null && allowedUrls.constructor === Array) {
        for (var i = 0; i < allowedUrls.length; i++) {
          if (allowedUrls[i] === this._getCurrentUrl()) return false;
        }
      }
      this._history.goToUrl(redirectionUrl);
      return true;
    }
    return false;
  };

  this._getCurrentUrl = function () {
    // Remove trailing slash
    return location.pathname.replace(/\/$/, '');
  };
}